<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useTabStore } from '@/stores/tab'

const tabStore = useTabStore()

const { tabs, currentTabIndex } = storeToRefs(tabStore)

const router = useRouter()

function onClick(item: (typeof tabs.value)[0]) {
  navigateTo({ path: item.path, query: item.query })
}

function onRemove(item: (typeof tabs.value)[0]) {
  const lastRoute = window.history.state.back
  const lastTab = tabs.value.find(tab => tab.path === lastRoute)

  tabStore.removeTab(item)

  const to = lastTab || tabs.value[currentTabIndex.value - 1]

  navigateTo({ path: to.path, query: to.query })
}

function removeTabsToLeft() {
  tabs.value.splice(0, Math.max(currentTabIndex.value, 0))
  currentTabIndex.value = 0
}

function removeTabsToRight() {
  tabs.value.splice(Math.min(currentTabIndex.value + 1, tabs.value.length))
}

function removeOtherTabs() {
  if (tabs.value.length === 1)
    return
  const currentTab = tabs.value[currentTabIndex.value]
  tabs.value = [currentTab]
  currentTabIndex.value = 0
}

function removeAllTabs() {
  if (tabs.value.length === 1)
    return
  tabs.value = []
  const { path, meta, name } = router.getRoutes().find(route => route.name === 'Home')!
  tabs.value.push({ path, meta, name, query: {} })
  currentTabIndex.value = 0
  navigateTo(path, { replace: true })
}

function handleCommand(command: string) {
  switch (command) {
    case 'left':
      removeTabsToLeft()
      break
    case 'right':
      removeTabsToRight()
      break
    case 'other':
      removeOtherTabs()
      break
    case 'all':
      removeAllTabs()
      break
  }
  tabStore.save()
}
</script>

<template>
  <div flex items-center gap-2>
    <div h-12 flex gap-10px items-center px-3 border-base b-b scroll-smooth overflow-auto>
      <div
        v-for="(item, index) in tabs" :key="item.path"
        class="tab-item flex-shrink  rounded-4px border-1 border-base hover:border-blue-400 hover:text-blue-400 px-2 h-26px text-ellipsis whitespace-pre flex-center"
        :class="index === currentTabIndex ? ' border-primary text-primary' : ''" @click="onClick(item)"
      >
        {{ item.meta?.title || item.path }}
        <div v-if="tabs.length !== 1" class=" i-ep-close   text-primary size-3.5 ml1" @click.stop="onRemove(item)" />
      </div>
    </div>
    <el-dropdown class="ml-auto flex-shrink-0" @command="handleCommand">
      <span class="hover:text-primary flex-center gap-1 mr-2">
        更多
        <div size-3 i-ep-arrow-down />
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="left">
            关闭左边
          </el-dropdown-item>
          <el-dropdown-item command="right">
            关闭右边
          </el-dropdown-item>
          <el-dropdown-item command="other">
            关闭其他
          </el-dropdown-item>
          <el-dropdown-item command="all">
            关闭全部
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<style scoped lang="scss">
.tab-item {
  cursor: pointer;
  transition: all 0.3s;

  .i-ep-close {
    width: 0;
    transition: all 0.3s;
  }

  &:hover {
    .i-ep-close {
      width: 14px;
    }
  }
}
</style>
